import { Coordinate, TileSize } from "../../models"

/** Inner edges of the bottom-aligned 64x48 hatch artwork. */
export const stairOpeningBounds = (at: Coordinate) => ({
    left: at.x * TileSize,
    right: (at.x + 1) * TileSize,
    north: at.y * TileSize + TileSize - 48 + 12,
    south: at.y * TileSize + TileSize - 48 + 39,
})
